import { DetailsList, IconButton, MessageBar, MessageBarType, ProgressIndicator, SelectionMode } from "@fluentui/react"
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from "react-accessible-accordion"
import { useApiCall } from "../hooks/apiHooks"
import { downloadBase64Content } from "../services/helperService"
import { IAccount } from "../types/IAccount"

interface RaterDialogProps {
	group: IAccount
}

export function QuoteHistory(props: RaterDialogProps) {
	const { group } = props
	const {
		data: quoteYears,
		loading: loadingQuoteHistory,
		error: errorGettingQuoteHistroy,
		fetchData: getQuoteHistory,
		setData: setQuotes
	} = useApiCall<any>(`/getQuoteHistory?groupId=${group.accountid}`)

	const downloadQuote = quote => {
		if (quote) {
			downloadBase64Content(quote.FileContent, quote.Name, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
		}
	}

	const getColumns = () => [
		{
			key: "fileName",
			name: "Name",
			fieldName: "fileName",
			minWidth: 300,
			maxWidth: 600,
			isResizable: true,
			onRender: item => <span>{item.Name}</span>
		},
		{
			key: "download",
			name: "",
			fieldName: "download",
			minWidth: 64,
			maxWidth: 64,
			onRender: item => <IconButton iconProps={{ iconName: "Download" }} onClick={() => downloadQuote(item)} />
		}
	]

	return (
		<div style={{ maxWidth: 740 }}>
			{loadingQuoteHistory && <ProgressIndicator />}
			{errorGettingQuoteHistroy && <MessageBar messageBarType={MessageBarType.error}>{errorGettingQuoteHistroy.message} </MessageBar>}
			{quoteYears && Object.keys(quoteYears).length > 0 && (
				<Accordion allowMultipleExpanded allowZeroExpanded={false} preExpanded={[`file-rows-${Object.keys(quoteYears)[0]}`]}>
					{Object.keys(quoteYears)
						.sort((a, b) => (a > b ? -1 : 1)) // Sort years in descending order
						.map(year => (
							<AccordionItem uuid={`file-rows-${year}`} key={year}>
								<AccordionItemHeading>
									<AccordionItemButton>{year}</AccordionItemButton>
								</AccordionItemHeading>
								<AccordionItemPanel>
									<DetailsList items={quoteYears[year]} columns={getColumns()} selectionMode={SelectionMode.none} />
								</AccordionItemPanel>
							</AccordionItem>
						))}
				</Accordion>
			)}
			{quoteYears && Object.keys(quoteYears).length === 0 && <MessageBar messageBarType={MessageBarType.info}>No quotes found for this group.</MessageBar>}
		</div>
	)
}
